import { Bot, MessageCircleMore } from "lucide-react";

export function Chatbot() {
    return (
        <div className="w-full h-full flex flex-col items-center justify-center p-6 bg-gradient-to-br from-white via-blue-50 to-blue-100 rounded-2xl shadow-lg border border-blue-100">
            <div className="flex flex-col items-center gap-6 text-center max-w-lg">
                <div className="flex items-center justify-center w-20 h-20 bg-blue-100 text-blue-600 rounded-full shadow-inner">
                    <Bot className="w-10 h-10" />
                </div>

                <h2 className="text-3xl font-bold text-zinc-900 leading-tight">
                    Seu novo atendente 24h por dia.
                </h2>

                <p className="text-zinc-700 text-base leading-relaxed">
                    O <strong>Chatbot I.A. do Cardapti</strong> já está disponível! Automatize seu atendimento via <strong>WhatsApp</strong> com inteligência artificial que responde, sugere produtos e até mesmo vende por você!
                </p>

                <a
                    href="https://wa.me/5516997415602?text=Olá! Tenho interesse no módulo de Chatbot IA do Cardapti."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-xl transition-all shadow-md hover:scale-105"
                >
                    <MessageCircleMore className="w-5 h-5" />
                    Falar com o Suporte no WhatsApp
                </a>

                <p className="text-xs text-zinc-500 italic mt-2">
                    * Disponível apenas para assinantes do módulo Chatbot IA.
                </p>
            </div>
        </div>
    );
}
